import React from 'react';

import PageArrows from './PageArrows';

import './ResultsFooter.sass';

export interface OwnProps {
    updateQueryString(key: string, value?: string): void;
}

export interface StateProps {
    currentPage: number;
    numPages: number;
    viewNumber: number;
    numResults: number;
}

type CombinedProps = StateProps & OwnProps;

const onChangeView = (event: React.MouseEvent<any>, updateQueryString: (key: string, value?: string) => void) => {
    event.preventDefault();
    updateQueryString('results_per_page', event.currentTarget.id);
};

const onChangePage = (event: React.MouseEvent<any>, updateQueryString: (key: string, value?: string) => void) => {
    event.preventDefault();
    updateQueryString('page', event.currentTarget.id);
};

// Returns an array of the ten page numbers surrounding the current page; five before and 4 after except when it is whithin 5 pages of the first or last page and will shift the numbers accordingly
const getSurroundingPageNums = (currentPage: number, numPages: number): number[] => {
    const maxNumPages = numPages < 10 ? numPages : 10;
    let startIndex: number;
    if (currentPage - 5 < 1) startIndex = 1;
    else if (currentPage + 4 > numPages) startIndex = numPages - maxNumPages + 1;   // plus one to include currentPage in result range
    else startIndex = currentPage - 5;
    return Array.apply(null, { length: maxNumPages }).map(Number.call, Number).map((iterationIndex: number) => {
        return startIndex + iterationIndex;
    });
};

const ResultsFooter: React.StatelessComponent<CombinedProps> = (props: CombinedProps) => {
    const { currentPage, numPages, viewNumber, numResults, updateQueryString } = props;
    return(
        <div className="Results-footer">
            <div className="Results-page-selector">
                <PageArrows curPage={currentPage} numPages={numPages} onChangePage={e => onChangePage(e, updateQueryString)}>
                {// Add 1 to pagenum and slice 1 from result for 1 indexing
                    getSurroundingPageNums(currentPage, numPages).map((pageNum: number) => {
                        return <a
                            key={pageNum}
                            href="#"
                            onClick={e => onChangePage(e, updateQueryString)}
                            className={currentPage === pageNum ? 'Current-page' : ''}
                            id={pageNum.toString()}
                        >{pageNum}
                        </a>;
                    })}
                </PageArrows>
            </div>
            <div className="View-selector">
                <span>{numResults} Items Total</span>
                <span className="seperator">|</span>
                <a href="#" onClick={e => onChangeView(e, updateQueryString)} id="12" className={viewNumber === 12 ? 'View-value-selected' : 'View-value'} >View 12</a>
                <span className="seperator">|</span>
                <a href="#" onClick={e => onChangeView(e, updateQueryString)} id="24" className={viewNumber === 24 ? 'View-value-selected' : 'View-value'} >View 24</a>
            </div>
        </div>
    );
};

export default ResultsFooter;



// WEBPACK FOOTER //
// ./src/components/global/application/results_footer/ResultsFooter.tsx